<div class="offcanvas offcanvas-top theme-bg" tabindex="-1" id="offcanvasTop">
    <div class="offcanvas-header">
        <a data-bs-dismiss="offcanvas" aria-label="Close">
            <i class="fas fa-times search-close" id="search-close"></i>
        </a>
    </div>
    <div class="offcanvas-body">
        <!-- Fullscreen search -->
        <div class="search-wrap">
            <form method="get">
                <input type="search" class="main-search-input" placeholder="Search Your Keyword...">
            </form>
        </div>
        <!-- end fullscreen search -->
    </div>
</div>

<div class="cart-menu-right cart-style-1 white-bg ">
    <div class="close-icon float-right">
        <a href="javascript:void(0);"><i class="bi bi-x"></i></a>
    </div>
    <div class="dropdown-cart-products">
        <div class="product">
            <div class="product__cart-details">
                <h5 class="product-title">
                    <a routerLink="/shop">Best color ful Lamp for ceiling</a>
                </h5>

                <span class="cart-product-info">
                    <span class="cart-product-qty">1</span>
                    x $84.00
                </span>
            </div>

            <figure class="product__image-container">
                <a routerLink="/shop" class="product-img">
                    <img src="assets/img/product/cart/product-01.jpg" alt="product">
                </a>
            </figure>
            <a href="javascript:void(0);" class="remove-btn" title="Product remove"><i class="fal fa-times"></i></a>
        </div>
        <div class="product">
            <div class="product__cart-details">
                <h5 class="product-title">
                    <a routerLink="/shop">Love color Table Lamp for room</a>
                </h5>

                <span class="cart-product-info">
                    <span class="cart-product-qty">1</span>
                    x $84.00
                </span>
            </div>

            <figure class="product__image-container">
                <a routerLink="/shop" class="product-img">
                    <img src="assets/img/product/cart/product-02.jpg" alt="product">
                </a>
            </figure>
            <a href="javascript:void(0);" class="remove-btn" title="Product remove"><i class="fal fa-times"></i></a>
        </div>
        <div class="product">
            <div class="product__cart-details">
                <h5 class="product-title">
                    <a routerLink="/shop">Best color ful Lamp for ceiling</a>
                </h5>

                <span class="cart-product-info">
                    <span class="cart-product-qty">1</span>
                    x $84.00
                </span>
            </div>

            <figure class="product__image-container">
                <a routerLink="/shop" class="product-img">
                    <img src="assets/img/product/cart/product-03.jpg" alt="product">
                </a>
            </figure>
            <a href="javascript:void(0);" class="remove-btn" title="Product remove"><i class="fal fa-times"></i></a>
        </div>
    </div>

    <div class="cart-total mb-15">
        <span>Total</span>
        <span class="cart-total-price">$160.00</span>
    </div>

    <div class="cart-action">
        <a routerLink="/cart" class="btn btn-primary">View Cart</a>
        <a routerLink="/checkout" class="btn btn-outline-primary-2"><span>Checkout</span><i class="fal fa-long-arrow-right"></i></a>
    </div>
</div>